import React, { useRef } from 'react';
import {
  ListBase,
  ListToolbar,
  Pagination,
  useRefresh,
  Title,
  useListContext,
  Datagrid,
  NumberField,
  TextField,
} from 'react-admin';

import { Card, makeStyles } from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';

import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { SECONDARY_COLOR } from '../../utils';
import { PERMISSAO_TELA_DESCONTOS_FUNCIONARIOS_LISTAR } from '../../utils/dadosTelas';
import DialogoCreateEdit from '../DescontoFuncionario/DialogoCreateEdit';
import DialogoDescontos from '../DescontoFuncionario/DialogoDescontos';
import DateMobillsInput from '../Transacoes/Inputs/DateInputMobills';
//import ActionsField from './Fields/ActionsField';
import Filter from './Filter';

const MES_ATUAL = new Date().getMonth();
const ANO_ATUAL = new Date().getFullYear();

const useStyles = makeStyles((theme) => ({
  dataHeader: {
    // marginLeft: '30px',
    // backgroundColor: 'red',
    flex: 1,
    backgroundColor: SECONDARY_COLOR,
    padding: '10px',
    color: 'white',
    fontWeight: 'bold',
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    // marginLeft: '30px',
    // backgroundColor: 'red',
    flex: 1,
    // backgroundColor: '#f8f8f8',
    padding: '10px',
    // color: 'rgba(0, 0, 0, 0.87)',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    // borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));
//
const MyList = ({ ...props }) => {
  const refDialogoDescontos = useRef(null);
  const refresh = useRefresh();
  const listContext = useListContext();
  const classes = useStyles();
  const { ids, filterValues, setFilters, displayedFilters } = listContext;
  const refDialogoCreateEdit = useRef(null);

  function handleCriar() {
    if (refDialogoCreateEdit.current) {
      refDialogoCreateEdit.current.handleCreate();
    }
  }

  const handleClose = () => {
    refresh();
  };

  function handleDialogoDesconto() {
    if (refDialogoDescontos.current) {
      refDialogoDescontos.current.handleOpen();
    }
  }

  function handleShow({ id }) {
    if (refDialogoDescontos.current) {
      refDialogoDescontos.current.handleOpen(id);
    }
  }

  return (
    <>
      <Title title="Desconto de funcionários" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList handleCriar={handleCriar} {...props} />}
        {...props}
      />
      <div>
        <DateMobillsInput />
      </div>
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Datagrid {...props}>
          <TextField
            source="username"
            label="Funcionário"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            sortable={false}
          />
          <NumberField
            source="total"
            locales="pt-BR"
            options={{
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
              style: 'currency',
              currency: 'BRL',
            }}
            label="Valor"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            sortable={false}
          />
          <ActionsField
            source="valor"
            textAlign="right"
            label="Ações"
            sortable={false}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            //handleShow={handleShow}
            actions={[
              {
                key: 'show',
                title: 'Detalhes',
                icon: <VisibilityIcon />,
                onClick: (rec) => handleShow(rec),
              },
            ]}
          />
        </Datagrid>
        <TransacoesPagination />
      </Card>
      <DialogoDescontos ref={refDialogoDescontos} />
      <DialogoCreateEdit ref={refDialogoCreateEdit} handleClose={handleClose} />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_DESCONTOS_FUNCIONARIOS_LISTAR}>
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Desconto de funcionários"
      component="div"
      filterDefaultValues={{
        periodo2: { mes: MES_ATUAL, ano: ANO_ATUAL },
      }}
    />
  </ProtegerPagina>
);

export default List2;
